module.exports = __webpack_public_path__ + "img/virtual.47c91418.svg";